import { useQuery } from 'react-query'
import { UseQueryOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { AlmanacFileSource, PlainText, SourceMaterialsMediaObject, Website } from 'types'

// Sources that can be fetched and polled via useSource / usePollSource.
// ExternalIntegration and ExampleBrand are excluded because they are never
// added as campaign context sources.
export type CampaignSourceObject = Website | PlainText | SourceMaterialsMediaObject | AlmanacFileSource

interface Data {
  source: CampaignSourceObject
}

export type SourceQueryOptions = Omit<UseQueryOptions<CampaignSourceObject>, 'queryKey' | 'queryFn'>

export const fetchSource = async (
  workspaceId: number,
  id: number,
  type: CampaignSourceObject['type'],
): Promise<CampaignSourceObject> => {
  const response = await sendToApi<Data>(`/w/${workspaceId}/sources/${id}?type=${type}`)

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(response.data)
  }

  return response.data.source
}

export const useSource = (id: number, type: CampaignSourceObject['type'], options?: SourceQueryOptions) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<CampaignSourceObject>(
    ['workspaces', workspaceId, 'sources', 'detail', id],
    () => fetchSource(workspaceId, id, type),
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
